import { createSlice } from '@reduxjs/toolkit';

const initialState = {

	meetingData : {
		upcomingMeetings : [],
		pastMeetings     : [] }

};

export const meetingSlice = createSlice({
	name     : 'meetings',
	initialState,
	reducers : {
		updateMeetingData : (state, action) =>
		{
			state.meetingData = { ...state.meetingData, ...action.payload };
		}

	}
});

export const { updateMeetingData } = meetingSlice.actions;
export default meetingSlice.reducer;
